module.exports = __webpack_public_path__ + "hbomaxar-static/media/HisDarkMaterials.224a2e92.png";